import { createSlice } from "@reduxjs/toolkit";
import { CompanyProps } from "../types";

const initialState: CompanyProps = {
  companyData: null,
};

const companyReducer = createSlice({
  name: "company",
  initialState: initialState,
  reducers: {
    fetchCompanySuccess(state, action) {
      return {
        ...state,
        companyData: action.payload,
      };
    },
  },
});

export default companyReducer.reducer;

export const { fetchCompanySuccess } = companyReducer.actions;
